<div>
    <div class="capthca-cell">
        <img [src]="captchaUrl" alt="{{ 'Common.CaptchaText' | translate }}" width="200" height="50" />
    </div>
    <div class="capthca-cell">
        <button class="btn btn-captcha"
            name="refreshCaptcha" (click)="refreshCaptchaEvent($event)">⟳</button>
    </div>
</div>
